import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Route, Routes } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
//Global styles
import { ThemeProvider } from 'styled-components';
import theme from './styles/theme';
import GlobalStyles from './styles/GlobalStyles';
import NaverMap from './component/map/NaverMap';
//RouterContext
import { BrowserRouter } from 'react-router-dom';
//Redux store
import store from './store/configureStore';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import ScreenProvider from './ScreenProvider';
import { Toaster } from 'react-hot-toast';
import { WebsocketProvider } from './hook/WebsocketContext';
import ModalCase from './component/common/modal/common/ModalCase';
const root = ReactDOM.createRoot(document.getElementById('root'));

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log(
          'Service Worker registered with scope:',
          registration.scope
        );
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}

const persistor = persistStore(store);
root.render(
  <BrowserRouter>
    <WebsocketProvider>
      <Toaster
        toastOptions={{
          success: {
            style: {
              fontSize: '18px',
              fontWeight: 700,
              letterSpacing: 0.5,
            },
            duration: 1500,
          },
          error: {
            style: {
              fontSize: '18px',
              fontWeight: 700,
              letterSpacing: 0.5,
              backgroundColor: '#ffe1e1',
            },
            duration: 2500,
          },
        }}
      />
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ScreenProvider />
            <ModalCase />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </WebsocketProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
